// extracted by mini-css-extract-plugin
export var chevron = "_lq-3";
export var chevronRotated = "_lq-4";
export var image = "_lq-1";
export var imageContainer = "_lq-0";
export var shippingAddress = "_lq-2";